import { render, staticRenderFns } from "./ItemListVenduto.vue?vue&type=template&id=462f574c"
import script from "./ItemListVenduto.vue?vue&type=script&lang=ts"
export * from "./ItemListVenduto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('462f574c')) {
      api.createRecord('462f574c', component.options)
    } else {
      api.reload('462f574c', component.options)
    }
    module.hot.accept("./ItemListVenduto.vue?vue&type=template&id=462f574c", function () {
      api.rerender('462f574c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemListVenduto.vue"
export default component.exports